<ion-header>
  <ion-toolbar color="dark">
    <ion-title class="title-delete">{{
      "delete-ticket-modal.title" | translate
    }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding content">
  <h3 class="title font-heavitas">{{ ticket.product.name }}</h3>
  @if (shouldShowReference()) {
  <p class="reference">
    {{ ticket.reference }}
  </p>
  }
  <p class="price">{{ getTicketAmount(ticket) | arsCurrency }}</p>
  <div class="image-wrapper">
    <img
      src="assets/images/scanner-result-warning.svg"
      class="icon-error icon-animation"
    />
  </div>
  <p class="message">{{ "delete-ticket-modal.message" | translate }}</p>
  <div class="btn-group">
    <ion-button
      expand="block"
      color="danger"
      (click)="confirmDelete()"
      class="delete-btn"
    >
      {{ "delete-ticket-modal.confirm" | translate }}
    </ion-button>
  </div>
</ion-content>
